import Highway from '@dogstudio/highway';
import Slideshow from '../_modules/slideshow';
import Menu from '../_modules/menu';

class Home extends Highway.Renderer {
  onEnter() {
    Slideshow.init();
    Menu.init();
    document.querySelectorAll('.slide__caption').forEach(caption => { caption.classList.remove('slide__caption--opacity') });
  }
}

export default Home;
